(function($) {


	/****************************************************************************************************
	Pour mettre en cache les éléments jQuery sélectionnés, remplacer $('#id') par $.selector('#id')
	*****************************************************************************************************/
	$.selector = function (selector) {
		if (!$.selector[selector]) $.selector[selector] = $(selector);		
		return $.selector[selector];
	};

	/****************************************************************************************************
	HOME
	*****************************************************************************************************/
	var HOME = {

		/* pour gérer le reclic sur la même élément du menu */
		previous: null,

		/* Désactive le lien "RECHERCHER" et Active - Désactive le volet de recherche */
		init: function() {

			if($('body.home').length) {

				// GESTION DES TEXTES DE LA HOME
				// *****************************
				// Les textes sont chargés dynamiquement (au clic) dans la div #hometexts
				// 
				// <div id='hometexts_wrapper'>
				// 		<div id='hometexts'></div>
				// </div>

				$('.main ul li').on('click', function() {

					$('.main ul li').removeClass('selected');
					$(this).addClass('selected');

					$zone = $('#hometexts_wrapper');
					$text  = $('#hometexts');

					var index = $(this).index();

					var lent = 500;
					var rapide = 100;

					/* reclic sur le même index de menu */
					if(index === HOME.previous) {
						$zone.animate({height: '0px'}, lent);
						$text.animate({opacity:0}, rapide);
						HOME.previous = null;
					} 

					else {

						var contenu = $('.main div:eq(' + (index + 2) + ')').html();

						/* la zone n'est pas ouverte */
						if ($zone.height() === 0 ) {
							$text.html(contenu);
							var height = $text.height() + 100 + 'px';
							$zone.animate({height: height}, lent, function() {
								$text.html(contenu).animate({opacity:1}, rapide);
							});
						} 

						/* La zone est déjà ouverte : on change le texte avec un fade avant de changer la hauteur de la zone */
						else {
							$text.animate({opacity:0}, rapide, function() {
								$text.html(contenu);					
								var height = $text.height() + 100 + 'px';
								$zone.animate({height: height}, lent, function() {
									$text.html(contenu).animate({opacity:1}, rapide);
								});
							});
						}
						
						HOME.previous = index;
					}
					

				});

				/* Clic sur gotoTop */
				$('.gototop').on('click', function() {
					$(".main").animate({ scrollTop: 0 }, "slow");
				});

				/* Clic sur lire un témoignage au hasard */
				/* input[name=all_temoignages_ids] contient les ids des 400 témoignages  */
				/* On en choisit un au hasard... */
				$('#lecturealeatoire').click(function() {
					var all = $("input[name=all_temoignages_ids]").val().split(',');
					var random_temoignage_id = all[Math.floor(Math.random() * all.length)];
					RESULTATS.load_temoignage(random_temoignage_id, false, 0);
					/* Change les liens pour les langues */
					$("#lang_switchers li").each(function(index){
						lienDebut =  $(this).find("a").attr("href").split("/digital/");
						newLien = lienDebut[0]+"/digital/"+random_temoignage_id+"/";
						$(this).find("a").attr("href",newLien);
					});

				});
				
			}			
		},

	};




	/****************************************************************************************************
	ZONE NOIRE A GAUCHE (RECHERCHER)
	*****************************************************************************************************/
	var LEFT_TOOLS = {		

		/* Désactive le lien "RECHERCHER" et Active - Désactive le volet de recherche */
		init: function() {			
			$("#rechercher").find("a").click(function(e) { e.preventDefault(); });
			$("#rechercher, #rech-droite").click(function() { $("#recherche").toggleClass('visible'); });
		}
	};


	/****************************************************************************************************
	ZONE DE RECHERCHE (LIBRE + AVANCEE + PAR PHOTOGRAPHES + TEXTES SCIENTIFIQUES)
	*************************************************************************************-****************/
	var RECHERCHE = {

		/* Navigation parmis les zones de recherche */
		init_navigation:function() {

			$('.recherche-perso').find("h2").click(function() {

				zone_cliquee = $(this).parent().attr('class'); /* temoignages, photographes ou textes */
				$cible       = $('.' + zone_cliquee).find(".zone_recherche");

				/* La zone est invisible, on l'affiche */
				if ($cible.hasClass('invisible')) {
					RECHERCHE.close_all_zones();

					$(this).addClass("opened");
					$cible.removeClass("invisible");

					MAIN.set_zone_recherche_ouverte(zone_cliquee);
					RECHERCHE.activate_zone_resultats(zone_cliquee);

					$("#rech-formulaire footer").css("top", "20px"); /* La position du footer de la zone de recherche varie */
				}
				else {
					RECHERCHE.close_all_zones();
					MAIN.set_zone_recherche_ouverte('');

					$("#rech-formulaire footer").css("top", "250px"); /* La position du footer de la zone de recherche varie */
				}

				return false;
			});

			/* Pour gérer les superpositions lors des transitions */
			$(".zone_recherche").on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
				if(!$(this).hasClass('invisible')) 
					$(this).css('overflow', 'visible');
			});


		},


		activate_zone_resultats: function(zone) {
			MAIN.set_zone_resultat_active(zone);			
			$("#res-temoignages, #res-photographes, #res-textes").addClass("invisible");
			$("#res-" + zone).removeClass("invisible");
		},


		close_photos_textes: function() {			
			if(MAIN.zone_recherche_ouverte === 'photographes' || MAIN.zone_recherche_ouverte === 'textes') {
				MAIN.set_zone_recherche_ouverte('');
				RECHERCHE.close_all_zones();
			}			
		},

		close_all_zones: function() {
			$("h2").removeClass("opened");
			$('.zone_recherche').addClass("invisible").css('overflow', 'hidden');
		},

		/* Open default zones */
		open_default_zones: function() {

			/* Affiche la zone de résultat active */
			$("#res-" + MAIN.zone_resultat_active).removeClass("invisible");

			if(MAIN.zone_recherche_ouverte !== '') {
				$zone = $('.' + MAIN.zone_recherche_ouverte);
				$zone.find('h2').addClass('opened');
				$zone.find('.zone_recherche').removeClass('invisible');
			}

		},





		/***************************************************/
		/* CHARGEMENT DES VALEURS PAR DEFAUT DES CHAMPS... */
		/* Valeurs enregistrées dans localstorage          */
		/***************************************************/
		set_initial_values: function() {

			var def = JSON.parse( localStorage.getItem( 'filtres' ) );

			if(def !== null) {
				$('input[name=s]').val(def.libre);
				$("select[name=naissance_continent]").val(def.naissance_continent).trigger("change", {update:false}).trigger("chosen:updated");
				$("select[name=naissance_pays]").val(def.naissance_pays).trigger("change", {update:false}).trigger("chosen:updated");
				$("select[name=naissance_ville]").val(def.naissance_ville).trigger("change", {update:false}).trigger("chosen:updated");
				$("select[name=residence_pays]").val(def.residence_pays).trigger("change", {update:false}).trigger("chosen:updated");
				$("select[name=residence_ville]").val(def.residence_ville).trigger("change", {update:false}).trigger("chosen:updated");
				$("select[name=langue]").val(def.lettre_langue).trigger("change", {update:false}).trigger("chosen:updated");
				$("select[name=decennie_naissance]").val(def.decennie_naissance).trigger("change", {update:false}).trigger("chosen:updated");			
				$("select[name=decennie_depart]").val(def.decennie_depart).trigger("change", {update:false}).trigger("chosen:updated");
				$("select[name=decennie_arrivee]").val(def.decennie_arrivee).trigger("change", {update:false}).trigger("chosen:updated");
				$("select[name=genre]").val(def.genre).trigger("change", {update:false}).trigger("chosen:updated");
				$("select[name=photographe]").val(def.photographe).trigger("change", {update:false}).trigger("chosen:updated");
			}

		},


	};


	/****************************************************************************************************
	RECHERCHE LIBRE
	*****************************************************************************************************/
	var RECHERCHE_LIBRE = {

		/* Activation (via la touche "entrée") */
		init: function() {

			$("#searchform").on('submit', function(event) {
				event.preventDefault();

				/* Réactive la zone de résultat "temoignages" */
				RECHERCHE.activate_zone_resultats('temoignages');

				/* ferme éventuellement les zones de recherche photographe et textes */
				RECHERCHE.close_photos_textes();

				MAIN.lancer_recherche();
			});

			/* click sur la X pour effacer le contenu de la recherche */
			$('#clear').on('click', function() {
				$('input[name=s]').val('');
				$(this).addClass('hidden');
				MAIN.lancer_recherche();
			});

			/* affiche la croix quand on entre du texte dans la recherche libre */
			$('input[name=s]').on('keyup', function() {		
				RECHERCHE_LIBRE.set_clear_button();
				MAIN.lancer_recherche();
			});

		},

		set_clear_button: function() {
			if($('input[name=s]').val() === '') {
				$('#clear').addClass('hidden');
			} else {
				$('#clear').removeClass('hidden');
			}
		}
	};



	/****************************************************************************************************
	RECHERCHE AVANCEE
	*****************************************************************************************************/
	var RECHERCHE_AVANCEE = {

		/* Initialisation des selects avec le JS chosen */
		init_chosen: function() {

			/* avec champ de recherche */
			$("select[name=naissance_pays], select[name=naissance_ville], select[name=residence_pays], select[name=residence_ville]").chosen({
				width:"40%",
				inherit_select_classes:true,
				no_results_text:"Pas de résultat",
				allow_single_deselect:true
			});

			/* sans champ de recherche */
			$("select[name=naissance_continent], select[name=langue], select[name=decennie_naissance], select[name=decennie_depart], select[name=decennie_arrivee], select[name=genre], select[name=photographe]").chosen({
				width:"40%",
				inherit_select_classes:true,
				disable_search:true
			});
		},


		init_on_change: function() {

			/* Continent de naissance */
			$.selector("select[name=naissance_continent]").on('change', function(evt, params) {
				RECHERCHE_AVANCEE.update_listes_from_continent(); /* Met à jour la liste des pays et villes correspondantes */
			});

			/* Pays de naissance et residence */
			$.selector("select[name=naissance_pays], select[name=residence_pays]").on('change', function(evt, params) {
				var type = this.name.substr(0, 9); /* naissance ou residence */
				RECHERCHE_AVANCEE.update_liste_villes_of_pays(type); /* Met à jour la liste des villes correspondantes */
			});

			/* Pour tous les champs select de la recherche avancée (pas photographes) */
			/* Cette fonction "principale" doit être éxécutée après les autres éventuelles fonctions liées à l'évenement 'Change' */
			/* pour être sûr que les champs sont à jour avant de lancer la recherche... */
			$("select[name=naissance_continent], select[name=naissance_pays], select[name=naissance_ville], select[name=residence_pays], select[name=residence_ville], select[name=langue], select[name=decennie_naissance], select[name=decennie_depart], select[name=decennie_arrivee], select[name=genre]").on('change', function(evt, params) {	

				/* affiche ou supprime le filtre correspondant */
				var filtre = "";
				if(this.selectedIndex > 0) filtre = "<span>" + $(this).find("option:selected").html() + "&nbsp;X</span>";
				$('.filtre[data-champ=' + this.name + ']').html(filtre);

				/* Relance la recherche s'il s'agit d'une mise à jour directe... */ 
				var update = (params !== undefined && params.update !== undefined) ? params.update : true;

				if(update) {
					// Sur les portables, affiche la zone de résultats
	    			//$('#rech-resultats').addClass('visible');
	    			$('#rech-resultats').fadeIn('slow');

	    			MAIN.lancer_recherche();
	    		}

	    	});

		},

		/* update listes pays et villes en fonction du continent sélectionné */
		update_listes_from_continent: function() {

			var continent = $.selector("select[name=naissance_continent]").val();

			$villes_et_pays = $.selector('select[name=naissance_pays], select[name=naissance_ville]');

			$villes_et_pays.find("option").each(function(index){
				if( continent === '' || $(this).attr("data-cont") === continent) $(this).show(); else $(this).hide();
			});

			$villes_et_pays.val('').trigger("chosen:updated").trigger('change', {update:false});

		},

		/* Update villes en fonction du pays sélectionné */
		update_liste_villes_of_pays: function(zone) {

			$select_ville = $.selector("select[name=" + zone + "_ville]");

			var pays      = $.selector("select[name=" + zone + "_pays]").val();
			var continent = (zone === "naissance") ? $.selector("select[name=naissance_continent]").val() : "";

			$select_ville.find("option").each(function(index) {
				var continent_ok = (continent === "" || $(this).attr("data-cont") === continent);
				var pays_ok      = (pays === "" || $(this).attr("data-pays") === pays);
				if(continent_ok && pays_ok) $(this).show();	else $(this).hide();
			});

			$select_ville.val('').trigger("chosen:updated").trigger('change', {update:false});
		},


	};



	/****************************************************************************************************
	RECHERCHE PAR PHTOGRAPHES
	*****************************************************************************************************/
	var RECHERCHE_PHOTOGRAPHES = {

		init: function() {
			$("select[name='photographe']").on('change', function(evt, params) { 

				/* Relance la recherche s'il s'agit d'une mise à jour directe... */ 
				var update = (params !== undefined && params.update !== undefined) ? params.update : true;

				if(update) {
					// Sur les portables, affiche la zone de résultats
	    			//$('#rech-resultats').addClass('visible');
	    			$('#rech-resultats').fadeIn('slow');
	    			
	    			MAIN.lancer_recherche();
	    		}
	    	});
		}

	};



	/****************************************************************************************************
	GESTION GLOBALE
	*****************************************************************************************************/

	var xhr_temoignage; 
	var xhr_photographes; /* l'objet qui sera retourné par les appels ajax - utilisé pour annuler une requête quand on en fait une autre */

	var MAIN = {

		zone_recherche_ouverte: localStorage.getItem('zone_recherche_ouverte') || '',
		zone_resultat_active: localStorage.getItem('zone_resultat_active') || 'temoignages',

		/* Tableaux d'objets XHR retournés par les appels ajax - utilisé pour annuler une requête quand on en fait une autre */
		/* Je stocke les appels à recherche "temoignage" et les appels "photographe" */
		xhr_calls: [],

		set_zone_recherche_ouverte: function(value) {
			MAIN.zone_recherche_ouverte = value;
			localStorage.setItem('zone_recherche_ouverte', value);
		},

		set_zone_resultat_active: function(value) {
			MAIN.zone_resultat_active = value;
			localStorage.setItem('zone_resultat_active', value);
		},

		/****************************************************************************************************
		Affiche le Spinner - Masque les résultats - Récupère les valeurs du formulaire
		Lance la recherche 
	    Charge les résultats dans la zone de résultats - Affiche la zone de résultats - Masque le spinner 
	    *****************************************************************************************************/
	    lancer_recherche: function(zone) {

	    	if (zone === undefined) zone = MAIN.zone_resultat_active;

	    	/* D'abord, enregistrer en local les filtres */
	    	var filtres = {};
	    	filtres.libre				= $('input[name=s]').val();
	    	filtres.naissance_continent = $.selector("select[name=naissance_continent]").val();
	    	filtres.naissance_pays      = $.selector("select[name=naissance_pays]").val();
	    	filtres.naissance_ville     = $.selector("select[name=naissance_ville]").val();
	    	filtres.residence_pays      = $.selector("select[name=residence_pays]").val();
	    	filtres.residence_ville     = $.selector("select[name=residence_ville]").val();
	    	filtres.lettre_langue       = $('select[name=langue]').val();
	    	filtres.decennie_naissance  = $('select[name=decennie_naissance]').val();
	    	filtres.decennie_depart     = $('select[name=decennie_depart]').val();
	    	filtres.decennie_arrivee    = $('select[name=decennie_arrivee]').val();
	    	filtres.genre               = $('select[name=genre]').val();
	    	filtres.photographe         = $('select[name=photographe]').val();
	    	localStorage.setItem( 'filtres', JSON.stringify(filtres) );

	    	$("#res-" + zone).find(".zone_spinner").addClass('visible');
	    	$("#res-" + zone).find(".zone_resultats").removeClass('visible');

	    	var actioncible = (zone == 'photographes') ? 'recherche_photographes' : 'recherche_temoignages';

	    	// Avant de lancer une nouvelle recherche, on annule celle en cours si il y en a une
	    	if(MAIN.xhr_calls[zone] && MAIN.xhr_calls[zone].readyState != 4) MAIN.xhr_calls[zone].abort();

	    	MAIN.xhr_calls[zone] = $.post( ajaxurl, { action : actioncible, 

	    		recherche_libre     : $('input[name=s]').val(),
	    		naissance_continent : $.selector("select[name=naissance_continent]").val(), 
	    		naissance_pays      : $.selector("select[name=naissance_pays]").val(),
	    		naissance_ville     : $.selector("select[name=naissance_ville]").val(),
	    		residence_pays      : $.selector("select[name=residence_pays]").val(),
	    		residence_ville     : $.selector("select[name=residence_ville]").val(),
	    		lettre_langue       : $('select[name=langue]').val(), 
	    		decennie_naissance  : $('select[name=decennie_naissance]').val(),
	    		decennie_depart     : $('select[name=decennie_depart]').val(),
	    		decennie_arrivee    : $('select[name=decennie_arrivee]').val(),
	    		genre               : $('select[name=genre]').val(),
	    		photographe         : $('select[name=photographe]').val()

	    	}, function(response) {

	    		$.selector("#res-" + zone).find(".zone_resultats")
	    		.empty()
	    		.append(response)
	    		.find(".lien_temoignage").click(RESULTATS.active_lien );    		
	    		

	    		$.selector("#res-" + zone).find(".zone_spinner").removeClass('visible');	
	    		$.selector("#res-" + zone).find(".zone_resultats").addClass('visible');

	    	});

	    },


	    /***************************************************************************/
	    /* SITUATIONS EXCEPTIONNELLES                                              */
	    /* Lors du chargement direct de la page d'un témoignage via l'url directe  */
	    /* du type http://www.encyclopedie-des-migrants.eu/digital/38/             */
	    /***************************************************************************/
	    situations_exceptionnelles: function() {	    	
	    	if($('body.single-post').length) {
	    		var temoignage_id = $('input[name=temoignage_id]').val();
	    		RESULTATS.load_temoignage(temoignage_id, true, 0);
	    	}
	    },


	};


	/****************************************************************************************************
	GESTION DES RESULTATS
	*****************************************************************************************************/
	var RESULTATS = {

		/* init du bouton - modifier la recherche - */
		init: function() {
			$("#modifier").on('click', function(evt, params) { 
				$("#rech-resultats").fadeOut('slow');				
			});
		},

		/* Lorsqu'on clique sur un filtre pour le supprimer, mettre à jour la recherche avancée, ce qui relance une recherche */
		init_filtres: function() {
			$('.filtre').click(function(){
				$(this).html("");
				var champ = $(this).data('champ');
				$("select[name=" + champ + "]").val('').trigger("change", {update:true}).trigger("chosen:updated");
			});
		},

		/* Un click sur un lien dans les résultats de recherche charge le témoignage et active le flexslider correspondant */
		active_lien: function(event) {

			event.preventDefault();
			var temoignage_id = "";
			temoignage_id = $(this).data('id');

			/* Pour les liens issus d'une recheche par photographe, on charge un témoignage en commençant par le dernier slide (startAt : -1) */
			var is_photo = $(this).hasClass('lien_photographe');
			var startAt = (is_photo) ? -1 : 0;

			/* On modifie l'url, et on remplace dans l'historique l'état actuel par l'état */
			History.replaceState(null, null, "/digital/" + temoignage_id + "/");

			/* Change les liens pour les langues */
			$("#lang_switchers li").each(function(index){
				lienDebut =  $(this).find("a").attr("href").split("/digital/");
				newLien = lienDebut[0]+"/digital/"+temoignage_id+"/";
				$(this).find("a").attr("href",newLien);
			});

			/* Retire la zone de recherche */
			$("#recherche").removeClass('visible');

			RESULTATS.load_temoignage(temoignage_id, false, startAt);
		},

		/* Charge un témoignage */
		/* wait : Il peut être nécessaire d'attendre un temps avant de charger les liens précédent / suivant */
		/* start : 0 -> le témoignage affiche en premier l'image / -1 -> le nom est affiché en premier */
		load_temoignage: function(temoignage_id, wait, start) {

			/* efface la zone main (qui contient théoriquement le témoignage...) */
			$(".main").empty();

			/* Rend visible la zone du témoignage */
			$.selector("#zone_temoignage").empty().addClass('visible');

			$.post( ajaxurl, { action : 'get_temoignage', id : temoignage_id}, function(response){
				$.selector("#zone_temoignage").append(response);
				$.selector("#zone_temoignage").find('.flexslider').flexslider({
					animation: "fade",
					slideshow: false,
					startAt: start
				});

				/* Le zoom sur les lettres */
				$.selector("#zone_temoignage").find('.lettre').click(function() {

					var zoomed = $(this).hasClass('zoomed');

					var hauteurViewport = window.innerHeight;
					hauteurMaxImage = hauteurViewport - 220;
					
					newmh = (zoomed) ? (hauteurMaxImage + 'px') : '1800px';

					$(this).toggleClass('zoomed').animate({"max-height" : newmh }, 300);
				});

				/* chargé les liens "Témoignage précédent" et "Témoignage suivant" */
				/* Dans la situation exceptionelle où un témoignage est chargé par reload du browser */
				/* il faut en plus attendre pour que les résultats de recherche soient chargés */
				/* (Sinon on ne peut pas trouver le témoignage suivant et le précédent...) */
				/* Dans ce cas uniquement, j'attends 5 secondes */
				if(wait) setTimeout(function(){ RESULTATS.load_prev_next(temoignage_id); }, 5000);
				else RESULTATS.load_prev_next(temoignage_id);

				RESULTATS.setTemoignageHeight();

			});
		},

		/* Lorsqu'un témoignage est chargé, recherche ce témoignage dans la liste des résultats de recherche */
		/* et active les liens témoignages précédent et suivant avec les liens qui vont bien */
		load_prev_next: function(temoignage_id) {
			var liste_ids  = $('input[name=liste_' + MAIN.zone_resultat_active + '_ids]').val();
			var liste = liste_ids.split(',');
			var position = liste.indexOf(temoignage_id.toString());
			var previousid = (position === 0) ? '' : liste[position-1];
			var nextid = (position === (liste.length-1)) ? '' : liste[position+1];
			$.selector("#zone_temoignage").find('#previous_temoignage').attr('data-id', previousid).attr('href', '/digital/' + previousid);
			$.selector("#zone_temoignage").find('#next_temoignage').attr('data-id', nextid).attr('href', '/digital/' + nextid);
			$.selector("#zone_temoignage").find('#previous_temoignage, #next_temoignage').click(RESULTATS.active_lien );
		},

		setTemoignageHeight: function() {
			var hauteurViewport = window.innerHeight;
			hauteurMaxTexte = hauteurViewport - 200;
			hauteurMaxImage = hauteurViewport - 220;
			$(".texte-wrapper, .lettre-wrapper").css('height', hauteurMaxTexte + 'px');
			$(".slides .image img:not(.zoomed)").css('max-height', hauteurMaxImage + 'px');
		}
	};







	/****************************************************************************************************
	AU CHARGEMENT DE LA PAGE
	*****************************************************************************************************/
	$(document).ready(function(){

		/* init HOME */
		HOME.init();

		/* init */
		LEFT_TOOLS.init();

		RECHERCHE.init_navigation();		

		RECHERCHE_LIBRE.init();
		RECHERCHE_AVANCEE.init_chosen();
		RECHERCHE_AVANCEE.init_on_change();
		RECHERCHE_PHOTOGRAPHES.init();

		RESULTATS.init();
		RESULTATS.init_filtres();

		/* On récupère les paramètres d'une éventuelle recherche précédente (sauvées en local storage) */
		/* Et on ouvre les zones devant être ouvertes */
		RECHERCHE.set_initial_values();
		RECHERCHE.open_default_zones();

		RECHERCHE_LIBRE.set_clear_button();
		
		/* On lance les recherches avancées et par photographes */
		MAIN.lancer_recherche('temoignages');
		MAIN.lancer_recherche('photographes');

		MAIN.situations_exceptionnelles();

	});

	/* Quand on retaille la fenetre, modifier la hauteur max des textes dans les flexsliders */
	$(window).resize(function() {			
		RESULTATS.setTemoignageHeight();
	});





})(jQuery);
